<template>
  <div v-if="feedItem.type === 'news-preview'"><NewsPreview :news-item="feedItem.item.item" :is-related-news="isRelatedNews" :preview-type="feedItem.item.previewType" :query-related="queryRelated" :sizing="feedItem.item.sizing" :max-width="maxWidth" :no-image="feedItem.item.noImage"></NewsPreview></div>
  <div v-else-if="feedItem.type === 'feed-list'"><FeedList :list-type="feedItem.item.listType" :count="feedItem.item.count"></FeedList></div>
  <div v-else-if="feedItem.type === 'person-profile'"><PersonProfile></PersonProfile></div>
  <div v-else-if="feedItem.type === 'discover-preview'"><DiscoverPreview :discoverItem="feedItem.item"></DiscoverPreview></div>
  <div v-else-if="feedItem.type === 'lassox-featured-ad'"><LassoxFeaturedAd :sizing="feedItem.sizing"></LassoxFeaturedAd></div>
  <div v-else-if="feedItem.type === 'ebook'"><Ebook :tall="feedItem.item.sizing || 'normal'" /></div>
  <div v-else-if="feedItem.type === 'webinar'"><WebinarNew :tall="feedItem.item.sizing || 'normal'" /></div>
</template>

<script>
import NewsPreview from '@/components/NewsPreview'
import DiscoverPreview from '@/components/DiscoverPreview'
import FeedList from '@/components/FeedList'
import PersonProfile from '@/components/PersonProfile'
import LassoxFeaturedAd from './LassoxFeaturedAd'
import Ebook from './Ebook.vue'
import WebinarNew from './WebinarNew.vue'
export default {
  name: 'newsPreview',
  props: {
    'feedItem': {
      type: Object,
      required: true
    },
    'query-related': {
      type: Boolean,
      required: false,
      default: false
    },
    isRelatedNews: {
      type: Boolean,
      required: false,
      default: false,
    },
    maxWidth: {
      type: String
    }
  },
  data () {
    return {
    }
  },
  computed: {
  },
  components: {
    NewsPreview,
    DiscoverPreview,
    FeedList,
    PersonProfile,
    LassoxFeaturedAd,
    Ebook,
    WebinarNew
  }
}
</script>

<style lang="less" scoped>

</style>
